<template>
    <v-container>
        <AdminTitleBar
            :title="loc('Confirm Content Removal')"
            :actions="titleBarActions"
            v-on:actionhandler="handleAction"
        />
        <v-card>
            <v-card-text class="removeconfirmation">
                <v-row>
                    <div class="label">{{ loc('ID') }}</div>
                    <div class="value">{{record._id || ""}}</div>
                </v-row>                
                <v-row v-if="record.type === 'page'">
                    <div class="label">{{ loc('Title') }}</div>
                    <div class="value">{{record.title || ""}}</div>
                </v-row>
                <v-row v-if="record.type === 'message'">
                    <div class="label">{{ loc('Subject') }}</div>
                    <div class="value">{{record.title || ""}}</div>
                </v-row>
                <v-row v-if="record.type !== 'page'">
                    <div class="label">{{ loc('Context') }}</div>
                    <div class="value">{{record.context || ""}}</div>
                </v-row>
                <v-row v-if="record.mime">
                    <div class="label">{{ loc('Type') }}</div>
                    <div class="value">{{record.mime || ""}}</div>
                </v-row>
                <v-row>
                    <div class="label">{{ loc('Created') }}</div>
                    <div class="value">{{record.created || ""}}</div>
                </v-row>
                <v-row>
                    <div class="label">{{ loc('Modified') }}</div>
                    <div class="value">{{record.modified || ""}}</div>
                </v-row>
                <v-row class='actionrow'>
                    <v-btn small color="error" dark @click="handleRemove()">{{ loc('Remove Record') }}</v-btn>
                    <v-btn small color="secondary" dark @click="handleAction('close')">{{ loc('Cancel') }}</v-btn>
                </v-row>                
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AdminTitleBar from "./Admin_TitleBar";

export default {
    name: "AdminContentRemove",
    props: {
        id: { type: [Object, Number, String] },
        record: { type: [Object, Boolean] }
    },
    components: { AdminTitleBar },
    data() {
        return {
            titleBarActions: [
                {
                    text: "Close",
                    key: "close"
                }
            ]
        }
    },
    computed: {
        ...mapState(['users', 'localize']),
    },
    methods: {
        loc: function (str) {
            return (this.localize.languages[this.users.lang] && this.localize.languages[this.users.lang][str]) || str;
        },          
        handleAction: function(action, params) {
            this.$emit("actionhandler", action, params);
        },
        handleRemove: function(){
            this.$emit("actionhandler", 'removeConfirmed', this.record);
        }
    }
}
</script>

